import ArrowDownToBracketIcon from "../../components/icons/ArrowDownToBracketIcon";
import { ReactNode, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../store/configureStore";
import {
    downloadFile,
    selectDownloadBlobUrl,
    selectDownloadFileError,
    selectDownloadFileLoading,
} from "../../store/slices/fileStorage";


interface FileDownloadButtonProps {
    fileName: string;
    fileRefId: number;
    icon?: ReactNode;
    disabled?: boolean;
    className?: string;
    classNameBtn?: string;
    onChange: (success: boolean, error?: string) => void;
}

const FileDownloadButton = ({
    fileName,
    fileRefId,
    icon,
    disabled = false,
    classNameBtn = '',
    className = '',
    onChange,
}: FileDownloadButtonProps) => {
    const { t } = useTranslation("common");
    const dispatch = useDispatch<AppDispatch>();
    const isDownloading = useSelector(selectDownloadFileLoading);
    const blobUrl = useSelector(selectDownloadBlobUrl);
    const downloadError = useSelector(selectDownloadFileError);
    const [error, setError] = useState<string>("");

    const handleDownload = useCallback(async () => {
        if (isDownloading || disabled) return;
        setError("");
        if (!fileName || fileRefId < 1) {
            const errorMsg = t("fileDownload.invalidInput");
            setError(errorMsg);
            onChange(false, errorMsg);
            return;
        }

        try {
            await dispatch(downloadFile(fileRefId, fileName));
            
        } catch {
            const errorMsg = t("fileDownload.downloadError");
            setError(errorMsg);
            onChange(false, errorMsg);
        }
    }, [dispatch, fileName, fileRefId, isDownloading, disabled, onChange, t]);

    // Success handler
    useEffect(() => {
        if (blobUrl) {
            setError("");
            onChange(true);
        }
    }, [blobUrl, fileName, onChange]);

    // Error handler
    useEffect(() => {
        if (downloadError?.extraData) {
            const { id } = downloadError.extraData as { id: number; fileName: string };
            if (fileRefId === id) {
                let errorMsg = downloadError.message;

                if (downloadError.code === 404) {
                    errorMsg = t("fileDownload.notFound");
                }

                setError(errorMsg);
                onChange(false, errorMsg);
            }
        }
    }, [downloadError, onChange]);

    return (
        <div className={`filedownload-btn ${className}`}>
            <button
                type="button"
                onClick={handleDownload}
                className={`${classNameBtn} ${error ?'alert alert-danger':''} visual-selection-aid`}
                disabled={isDownloading || disabled}
                title={
                    error ? error :
                    isDownloading
                        ? t("fileDownload.downloading")
                        : t("fileDownload.download")
                }
            >
                {icon ? (
                    <span>{icon}</span>
                ) : (
                      <ArrowDownToBracketIcon className="svg-inline--fa icon" />
                )}
            </button>

            {/*{error && (*/}
            {/*    <div*/}
            {/*        className="alert alert-danger invalid-feedback mt-2 p-1 position-relative"*/}
            {/*        role="alert"*/}
            {/*    >*/}
            {/*        <span>{error}</span>*/}
            {/*    </div>*/}
            {/*)}*/}
        </div>
    );
};

export default FileDownloadButton;
